export default {
  params: ['target'],
  validate: (value, { target }) => value === target
}
